var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full relative"},[_c('img',{staticClass:"loading absolute",attrs:{"src":"https://abroad-sin-static.shengqugames-corp.com/wpay/icon_loading.png","alt":"loading"}})])
}]

export { render, staticRenderFns }